import axios from "@/axios";
// import * as types from '@/store/mutation-types'

export default {
    namespaced: true,

    state: {},

    actions: {
        delete({ commit }, { id }) {
            return axios.delete(`/SettingsHr/LeavesOrPermissionType/${id}`)
        }
    }
}